export interface IAnswer {
  answerId: string;
  houseFlatId: string;
  os: string;
  version: string;
  brand: string;
  model: string;
  description: string;
  uidAnsweredBy?: string;
  createdAt: string;
}

export class Answer {
  answerId: string;
  houseFlatId: string;
  os: string;
  version: string;
  brand: string;
  model: string;
  description: string;
  uidAnsweredBy?: string;
  createdAt: string;

  constructor(data: IAnswer) {
    this.answerId = data.answerId;
    this.houseFlatId = data.houseFlatId;
    this.os = data.os;
    this.version = data.version;
    this.brand = data.brand;
    this.model = data.model;
    this.description = data.description;
    this.uidAnsweredBy = data.uidAnsweredBy;
    this.createdAt = data.createdAt;
  }
}
